module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "noind sgc-1",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }), _c('i', [_vm._v("If a man cannot forget, he will never amount to much.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Søren Kierkegaard, "), _c('i', [_vm._v("Either/Or")])]), _vm._v(" "), _c('p', {
    staticClass: "noind sgc-2"
  }, [_vm._v("… We know now that the modern world is coming to an end… at the same time, the unbeliever will emerge from the fogs of secularism. He will cease to reap benefit from the values and forces developed by the very Revelation he denies… Loneliness in faith will be terrible. Love will disappear from the face of the public world, but the more precious will be that love which flows from one lonely person to another… the world to come will be filled with animosity and danger, but it will be a world open and clean.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Romano Guardini, "), _c('i', [_vm._v("The End of the Modern World")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60578642","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/5-start.vue
// module id = 72
// module chunks = 0